

/**
 * Запросы размеров изображения
 */
export const ImageRequest = {
    tile: {
        qvga: 'qvga',
        vga: 'qvga',
        hd: 'vga',
        fhd: 'vga',
        '2k': 'vga',
        '4k': 'hd',
        '5k': 'hd',
        '8k': 'hd',
    },
    image: {
        qvga: 'qvga',
        vga: 'vga',
        hd: 'hd',
        fhd: 'hd',
        '2k': 'hd',
        '4k': 'fhd',
        '5k': '2k',
        '8k': '4k',
    },
};


/**
 * Запросы размеров изображения
 */
export const ImageRequest = {
    tile: {
        qvga: 'qvga',
        vga: 'qvga',
        hd: 'vga',
        fhd: 'vga',
        '2k': 'vga',
        '4k': 'hd',
        '5k': 'hd',
        '8k': 'hd',
    },
    image: {
        qvga: 'qvga',
        vga: 'vga',
        hd: 'hd',
        fhd: 'hd',
        '2k': 'hd',
        '4k': 'fhd',
        '5k': '2k',
        '8k': '4k',
    },
};
